<div class="sign-field">
    <input type="text" aria-label="Text" [id]="id" (change)="textOnChange($event.target.value)"/>
    <label [for]="id">{{labelText}}</label>
  </div>
  
  